// 手機底部選單的移動選取底板（移植自切版 js/shared-shell.js 的 KatsuwinDockMotion）
// 選取狀態仍由 Vue 的 li.active 決定，這裡只計算底板位置，寫到 ul 的 --dock-selection-* 與 data-dock-* 屬性
export function initDockMotion(track) {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)')
  let selected = null
  let frame = 0

  const animateIcon = item => {
    if (!item || reduced.matches) return
    if (item.dataset.identifier) {
      track.removeAttribute('data-dock-bounce')
      // 每次點選（含重複點同一格）都重新觸發底板回彈
      void track.offsetWidth
      track.setAttribute('data-dock-bounce', '')
    }
    // icon 與文字一起回彈，點擊範圍不移動
    item.querySelectorAll(':scope > i, :scope > span').forEach(content => {
      if (!content.animate) return
      content.getAnimations().forEach(animation => animation.cancel())
      content.animate([
        { transform: 'scale(1)' },
        { transform: 'scale(1.2)', offset: 0.28 },
        { transform: 'scale(.97)', offset: 0.66 },
        { transform: 'scale(1.025)', offset: 0.84 },
        { transform: 'scale(1)' }
      ], { duration: 460, easing: 'cubic-bezier(.2,.65,.3,1)' })
    })
  }

  const sync = () => {
    if (!track.getClientRects().length) return
    const visible = [...track.children].filter(item => item.tagName === 'LI' && item.getClientRects().length && getComputedStyle(item).display !== 'none')
    const search = visible.find(item => item.id === 'nav-ft-search')
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0
    track.style.setProperty('--dock-search-space', `${search ? search.offsetWidth + gap : 0}px`)
    const next = visible.find(item => item.dataset.identifier && item.classList.contains('active'))
    const icon = next && next.querySelector(':scope > i')
    if (!icon) {
      track.removeAttribute('data-dock-indicator')
      selected = null
      return
    }
    const bounds = track.getBoundingClientRect()
    const itemBounds = next.getBoundingClientRect()
    // 底板包住整格（內縮 4px），用 offset 計算，按壓／icon 動畫期間位置不會跳動
    track.style.setProperty('--dock-selection-x', `${itemBounds.left - bounds.left + 4}px`)
    track.style.setProperty('--dock-selection-y', `${itemBounds.top - bounds.top + 4}px`)
    track.style.setProperty('--dock-selection-width', `${next.offsetWidth - 8}px`)
    track.style.setProperty('--dock-selection-height', `${next.offsetHeight - 8}px`)
    if (selected !== next && selected !== null) animateIcon(next)
    selected = next
    if (!track.hasAttribute('data-dock-indicator')) {
      track.setAttribute('data-dock-indicator', '')
      // 第一次定位不做轉場，下一幀才開啟 transition
      requestAnimationFrame(() => requestAnimationFrame(() => track.setAttribute('data-dock-animated', '')))
    }
  }

  const queue = () => {
    cancelAnimationFrame(frame)
    frame = requestAnimationFrame(sync)
  }

  const mutationObserver = new MutationObserver(records => {
    if (records.some(record => record.target !== track || record.type === 'childList')) queue()
  })
  mutationObserver.observe(track, { childList: true, attributes: true, subtree: true, attributeFilter: ['class', 'hidden', 'style'] })
  const resizeObserver = window.ResizeObserver ? new ResizeObserver(queue) : null
  if (resizeObserver) resizeObserver.observe(track)

  const onClick = event => {
    const item = event.target.closest('li')
    if (item && (item === selected || !selected || !item.dataset.identifier)) animateIcon(item)
  }
  track.addEventListener('click', onClick)
  if (document.fonts) document.fonts.ready.then(queue)
  sync()

  return () => {
    cancelAnimationFrame(frame)
    mutationObserver.disconnect()
    if (resizeObserver) resizeObserver.disconnect()
    track.removeEventListener('click', onClick)
  }
}
